var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.262 27.364a.748.748 0 1 0 0 1.496.748.748 0 0 0 0-1.495z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22.369 15.05-.056-.332a10.456 10.456 0 0 0-9.565-8.71V2.783l3.974-1.325A.748.748 0 0 0 16.25.04l-4.486 1.495a.748.748 0 0 0-.51.71v3.765a10.456 10.456 0 0 0-9.567 8.71l-.055.33a2.244 2.244 0 0 0-.005 4.293l2.699 17.065a2.237 2.237 0 0 0 2.213 1.873h10.924c1.101 0 2.032-.788 2.214-1.88l2.698-17.057a2.245 2.245 0 0 0-.005-4.293zM11.252 7.508v3.474a.748.748 0 0 0 1.496 0V7.508a8.961 8.961 0 0 1 8.088 7.445H3.163a8.928 8.928 0 0 1 8.09-7.445zm9.048 15.37H3.7l-.545-3.439h17.69l-.544 3.44zm-1.419 8.973H5.118l-1.182-7.477h16.128L18.88 31.85zm-1.419 4.934H6.537a.744.744 0 0 1-.736-.618l-.446-2.821h13.29L18.2 36.16a.745.745 0 0 1-.738.625zm4.257-18.841H2.28a.748.748 0 0 1 0-1.495h19.441a.748.748 0 0 1-.002 1.495z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.738 27.364h-4.486a.748.748 0 0 0 0 1.496h4.486a.748.748 0 0 0 0-1.495z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/Coffee.50daa542.svg";
export { ForwardRef as ReactComponent };